export type ArticleShareNetwork = 'facebook' | 'linkedin' | 'x' | 'reddit'
type ArticleShareSource = ArticleShareNetwork | 'copy_link'

/** Use the public browser path, never Next's rewritten route or incoming tracking params. */
export const buildArticleShareUrl = (pathname: string, source: ArticleShareSource) => {
  const url = new URL('https://www.hearingtracker.com')
  url.pathname = pathname
  url.searchParams.set('utm_source', source)
  url.searchParams.set('utm_medium', source === 'copy_link' ? 'referral' : 'social')
  url.searchParams.set('utm_campaign', 'article_share')
  url.searchParams.set('utm_content', 'article_footer')
  return url.toString()
}

export const buildArticleShareHref = (network: ArticleShareNetwork, pathname: string, title: string) => {
  const url = encodeURIComponent(buildArticleShareUrl(pathname, network))

  switch (network) {
    case 'facebook':
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`
    case 'linkedin':
      return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`
    case 'x':
      return `https://twitter.com/intent/tweet?url=${url}&text=${encodeURIComponent(title)}&via=hearingtracker`
    case 'reddit':
      return `https://www.reddit.com/submit?url=${url}&title=${encodeURIComponent(title)}`
  }
}
